export default {

    indexRegions:   { method: 'get',    url: 'regions' },
    storeRegion:    { method: 'post',   url: 'regions' },
    updateRegion:   { method: 'put',    url: 'regions/{id}'},
    destroyRegion:  { method: 'delete', url: 'regions/{id}'},

}